"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatsigUser = exports.useStatsigClient = exports.useStatsigOnDeviceEvalClient = exports.useLayer = exports.useFeatureGate = exports.useGateValue = exports.useExperiment = exports.useDynamicConfig = exports.StatsigProvider = exports.StatsigContext = void 0;
const StatsigContext_1 = require("./StatsigContext");
exports.StatsigContext = StatsigContext_1.default;
const StatsigProvider_1 = require("./StatsigProvider");
Object.defineProperty(exports, "StatsigProvider", { enumerable: true, get: function () { return StatsigProvider_1.StatsigProvider; } });
const useDynamicConfig_1 = require("./useDynamicConfig");
exports.useDynamicConfig = useDynamicConfig_1.default;
const useExperiment_1 = require("./useExperiment");
exports.useExperiment = useExperiment_1.default;
const useFeatureGate_1 = require("./useFeatureGate");
exports.useFeatureGate = useFeatureGate_1.default;
const useGateValue_1 = require("./useGateValue");
exports.useGateValue = useGateValue_1.default;
const useLayer_1 = require("./useLayer");
exports.useLayer = useLayer_1.default;
const useStatsigClient_1 = require("./useStatsigClient");
Object.defineProperty(exports, "useStatsigClient", { enumerable: true, get: function () { return useStatsigClient_1.useStatsigClient; } });
const useStatsigOnDeviceEvalClient_1 = require("./useStatsigOnDeviceEvalClient");
Object.defineProperty(exports, "useStatsigOnDeviceEvalClient", { enumerable: true, get: function () { return useStatsigOnDeviceEvalClient_1.useStatsigOnDeviceEvalClient; } });
const useStatsigUser_1 = require("./useStatsigUser");
Object.defineProperty(exports, "useStatsigUser", { enumerable: true, get: function () { return useStatsigUser_1.useStatsigUser; } });
__STATSIG__ = Object.assign(Object.assign({}, (__STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {})), { StatsigContext: StatsigContext_1.default,
    StatsigProvider: StatsigProvider_1.StatsigProvider,
    useDynamicConfig: useDynamicConfig_1.default,
    useExperiment: useExperiment_1.default,
    useGateValue: useGateValue_1.default,
    useFeatureGate: useFeatureGate_1.default,
    useLayer: useLayer_1.default,
    useStatsigOnDeviceEvalClient: useStatsigOnDeviceEvalClient_1.useStatsigOnDeviceEvalClient,
    useStatsigClient: useStatsigClient_1.useStatsigClient });
